import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import queryString from 'query-string';
import moment from 'moment';
import { retrieveData } from '../actions/fetch-data';
import { popupOpen } from '../actions/pop-ups';
import Header from '../components/headers/header';
import Pagination from '../components/search/search-pagination';
import SortButtons from '../components/tables/sort-buttons';

import { GET_ORDERS_DATA, VIEW_ORDER_POPUP } from '../constants/constants';
import { ORDERS } from '../constants/endpoints';

class OrdersPage extends React.Component {
    componentDidMount() {
        const { query } = this.props.location;
        const searchParams = queryString.stringify(query);
        const url = `${ORDERS}?${searchParams}`;

        this.props.retrieveData(url, GET_ORDERS_DATA);
    }

    renderOrders() {
        const { orders } = this.props.state;
        if (!Array.isArray(orders.data) || orders.data.length === 0) {
            return (
                <tr>
                    <td colSpan="5">No orders found</td>
                </tr>
            );
        }

        return orders.data.map((order, index) => {
            const { payment } = order;
            return (
                <tr key={index}>
                    <td>{order.first_name} {order.last_name}</td>
                    <td>{order.email}</td>
                    <td>{moment(order.created_at).format('MMMM Do YYYY')}</td>
                    <td>{payment}</td>
                    <td>
                        <span className="tag-item__badge" onClick={() => this.props.popupOpen(VIEW_ORDER_POPUP, order)}>
                            View
                        </span>
                    </td>
                </tr>
            );
        });
    }

    render() {
        return (
            <div>
                <Header title="Orders" subtitle="Manage orders" />
                <div className="content">
                    <table width="100%" className="pure-table pure-table-horizontal pure-table-striped order-table">
                        <thead>
                            <tr>
                                <th>
                                    Name <SortButtons searchKey="name" />
                                </th>
                                <th>
                                    Email <SortButtons searchKey="email" />
                                </th>
                                <th>
                                    Created <SortButtons searchKey="created_at" />
                                </th>
                                <th>Payment status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>

                        <tbody>{this.renderOrders()}</tbody>
                    </table>

                    {this.props.state.asyncAction.requestActive ? null : (
                        <Pagination totalPages={this.props.state.orders.totalPages} location={this.props.location} />
                    )}
                </div>
            </div>
        );
    }
}

export default connect(nextState => ({ state: nextState }), { retrieveData, popupOpen })(OrdersPage);
